/**
 * Socket rejection codes the host app reacts to. Mirrors `SvaraErrorCode` in
 * trinity-nest (libs/shared/utils/src/lib/socket-data/svara/error-codes.ts); the
 * websocket gateway puts the code on every failed reply as `errorCode` and as
 * `data.error.code`. Only the codes this app branches on are listed — the game
 * bundle handles the rest itself.
 */
export const SvaraErrorCode = {
	/** Player's level is outside the room's range (below minLevel or above maxLevel). */
	InvalidLevelForTable: 33,
} as const;

/** Reads the code off a failed socket reply, whichever of the two places it is in. */
export const socketErrorCode = (payload: unknown): number | undefined => {
	if (!payload || typeof payload !== 'object') return undefined;
	const p = payload as { errorCode?: unknown; data?: { error?: { code?: unknown } } };
	const code = typeof p.errorCode === 'number' ? p.errorCode : p.data?.error?.code;
	return typeof code === 'number' ? code : undefined;
};
